
import { computed, defineComponent, PropType, reactive, toRefs } from 'vue';
import { Bid } from '@/types/app';
import AppTable from '@/components/tables/base/AppTable.vue';
import Timestamp from '@/components/tables/TimestampCell.vue';
import { createGeoPoint, useTableSorting } from '@/utils';
import MaterialIcon from '@/components/MaterialIcon.vue';
import { Location } from '@/types/shared';

export default defineComponent({
  name: 'BidsTable',
  components: {
    AppTable,
    Timestamp,
    MaterialIcon
  },
  props: {
    bids: {
      type: Array as PropType<Array<Bid>>,
      default: () => []
    }
  },
  setup(props) {
    const { bids } = toRefs(props);

    const defaultLocation: Location = reactive({
      geoPoint: createGeoPoint(0, 0),
      address: ''
    });

    const normalizedBids = computed(() => {
      return bids.value.map(bid => ({
        ...bid,
        materialList: bid.materialList.map(materialListItem => ({
          ...materialListItem,
          location:
            {
              ...materialListItem.location,
              geoPoint: materialListItem.location?.geoPoint ?? defaultLocation.geoPoint
            } ?? defaultLocation
        }))
      }));
    });

    const { sortedData: sortedBids, sortBy, getSortState } = useTableSorting(normalizedBids, 'jobName');

    return {
      sortedBids,
      sortBy,
      getSortState
    };
  }
});
